import { useCallback } from 'react';
import { trackEvent } from 'helpers/analytics';

export const useContactsSort = ({ onSetFilters, queryParams, activeNetwork, type, listId, page, list }) =>
  useCallback(
    (args) => {
      onSetFilters({
        ...queryParams.filters,
        sortBy: args.value === 'relevance' ? '' : args.value,
        sortDirection: args.value === 'relevance' ? '' : args.direction,
        page: 1,
      });
      trackEvent('contacts:change_sort', {
        collectionId: activeNetwork.id,
        listId: type === 'public' ? listId : list?.id,
        columnName: args.label,
        sortDirection: args.direction,
        page,
      });
    },
    [onSetFilters, queryParams, activeNetwork, type, listId, page, list],
  );
